import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  TextField
} from '@mui/material';

import {
  DescriptionOutlined
} from '@mui/icons-material';

import {
  multitextFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import {
  templateButtonIconSx,
  templateButtonSx,
  templateButtonWrapperSx,
  templateSectionSx
} from './SoapEntryStyles';

const TemplateSection = ({
  label,
  buttonText,
  value,
  onChange,
  onTemplateOpen
}) => {
  return (
    <Box sx={templateSectionSx}>
      <Box sx={templateButtonWrapperSx}>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          onClick={onTemplateOpen}
          sx={templateButtonSx}>
          <DescriptionOutlined sx={templateButtonIconSx} />

          {buttonText}
        </Button>
      </Box>

      <TextField
        fullWidth
        multiline
        minRows={4}
        label={label}
        value={value}
        onChange={event => onChange(event.target.value)}
        sx={multitextFieldSx}
      />
    </Box>
  );
};

TemplateSection.propTypes = {
  label: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onTemplateOpen: PropTypes.func.isRequired
};

export default TemplateSection;